<template>
  <div class="wg-col wg-xs-12" style="padding: 2%">
    <wg-modal
      v-if="openModal"
      :width="windowWidth > 700 ? '500px' : '80%'"
      :portal="true"
      @closeModal="closeModal"
    >
      <div slot="header" class="com-anm22-app-text-xl">
        <span class="ticket-modal-title">{{
          mode == "edit"
            ? $anm22.strLang(lang, "Edit", "Modifica " + currentTicket.name)
            : $anm22.strLang(lang, "New", "Nuovo")
        }}</span>
        <div v-if="showUpdatedBadge == true" class="ticket-updated-badge">
          ✓
        </div>
      </div>

      <div slot="body">
        <div v-if="ticketTab == 'main'">
          <ticket-print
            v-if="currentTicket.idWorldCard"
            :ticketId="currentTicket.idWorldCard"
            :ticket="currentTicket"
            :printTrigger="printRequestTrigger"
          ></ticket-print>
          <div v-if="mode == 'edit'" class="ticket-action-cards">
            <div v-if="currentTicket.amount > 1" class="action-card inside">
              {{ $anm22.strLang(lang, "Entered", "Entrato") }}
            </div>
            <div
              v-if="currentTicket.enabled && currentTicket.enabled === true"
              class="action-card done"
            >
              {{ $anm22.strLang(lang, "Enabled", "Abilitato") }}
            </div>
            <div
              v-if="
                typeof currentTicket.enabled != 'undefined' &&
                currentTicket.enabled === false
              "
              class="action-card error"
            >
              {{ $anm22.strLang(lang, "Not enabled", "Non abilitato") }}
            </div>
            <div
              v-if="
                getTicketType(currentTicket) &&
                getTicketType(currentTicket).requiredBracelet
              "
              class="action-card link bracelet"
              @click="changeTicketTab('bracelet')"
            >
              {{
                currentTicket.physicalPassStatus
                  ? $anm22.strLang(lang, "Pass delivered", "Pass cansegnato")
                  : $anm22.strLang(
                      lang,
                      "Pass not delivered",
                      "Pass non consegnato",
                    )
              }}
            </div>
            <div
              v-if="
                currentTicket.companyEmail && !currentTicket.companyUserOwner
              "
              class="action-card warning"
            >
              {{
                $anm22.strLang(
                  lang,
                  "Manager not registered",
                  "Manager non registrato",
                )
              }}
            </div>
            <div
              v-if="currentTicket.email && !currentTicket.userOwner"
              class="action-card warning"
            >
              {{
                $anm22.strLang(
                  lang,
                  "User not registered",
                  "Utente non registrato",
                )
              }}
            </div>
            <div class="action-card link list" @click="changeTicketTab('logs')">
              {{ $anm22.strLang(lang, "Logs", "Log") }}
            </div>
            <div
              v-if="currentTicket.email && currentTicket.enabled"
              class="action-card link email"
              @click="changeTicketTab('mail')"
            >
              {{
                $anm22.strLang(lang, "Send pass copy", "Invia pass via e-mail")
              }}
            </div>
            <div class="action-card link print" @click="printRequestTrigger++">
              {{ $anm22.strLang(lang, "Print pass", "Stampa pass") }}
            </div>
          </div>
          <div v-if="mode == 'edit'" class="ticket-id">
            ID: CIV-{{ currentTicket.idWorldCard }}
          </div>
          <span>{{ $anm22.strLang(lang, "Type", "Tipologia") }}</span>
          <div class="wg-col">
            <select
              class="input-elem print-elem com-anm22-app-select"
              v-model="currentTicket.cardType"
            >
              <option
                v-for="(ticketType, index) in ticketTypes.filter(
                  (t) => !t.deleted,
                )"
                :key="index"
                :value="ticketType.idWorldCardType"
              >
                {{ ticketType.name }}
              </option>
            </select>
            <div class="vertical-height-div" style="height: 12px"></div>
          </div>
          <span>{{ $anm22.strLang(lang, "Company", "Azienda") }}</span>
          <div class="wg-col">
            <input
              class="input-elem print-elem com-anm22-app-input-text"
              type="text"
              v-model="currentTicket.name"
            />
            <div class="vertical-height-div" style="height: 12px"></div>
          </div>
          <span>{{
            $anm22.strLang(lang, "Company e-mail", "Indirizzo e-mail azienda")
          }}</span>
          <div class="wg-col">
            <input
              class="input-elem print-elem com-anm22-app-input-text"
              type="email"
              v-model="currentTicket.companyEmail"
            />
            <div class="vertical-height-div" style="height: 12px"></div>
          </div>
          <div style="border-top: 1px solid #ccc; margin-bottom: 10px"></div>
          <span>{{
            $anm22.strLang(lang, "E-mail address", "Indirizzo e-mail")
          }}</span>
          <div class="wg-col">
            <input
              class="input-elem print-elem com-anm22-app-input-text"
              type="email"
              v-model="currentTicket.email"
            />
            <div class="vertical-height-div" style="height: 12px"></div>
          </div>
          <span>{{ $anm22.strLang(lang, "First name", "Nome") }}</span>
          <div class="wg-col">
            <input
              class="input-elem print-elem com-anm22-app-input-text"
              type="text"
              v-model="currentTicket.firstName"
            />
            <div class="vertical-height-div" style="height: 12px"></div>
          </div>
          <span>{{ $anm22.strLang(lang, "Last name", "Cognome") }}</span>
          <div class="wg-col">
            <input
              class="input-elem print-elem com-anm22-app-input-text"
              type="text"
              v-model="currentTicket.lastName"
            />
            <div class="vertical-height-div" style="height: 12px"></div>
          </div>
          <template
            v-if="
              !currentTicket.cardType ||
              (!ticketTypes.filter(
                (t) => t.idWorldCardType == currentTicket.cardType,
              )[0].isVehicle &&
                !ticketTypes.filter(
                  (t) => t.idWorldCardType == currentTicket.cardType,
                )[0].isFood)
            "
          >
            <span>{{ $anm22.strLang(lang, "Role", "Ruolo") }}</span>
            <div class="wg-col">
              <select
                class="input-elem print-elem com-anm22-app-select"
                v-model="currentTicket.role"
              >
                <option
                  v-for="(role, index) in ticketRoles"
                  :key="index"
                  :value="role.id"
                >
                  {{ role.name }}
                </option>
              </select>
              <div class="vertical-height-div" style="height: 12px"></div>
            </div>
            <span>{{ $anm22.strLang(lang, "FMI member", "Tessera FMI") }}</span>
            <div class="wg-col">
              <input
                class="input-elem print-elem com-anm22-app-input-text"
                :style="{
                  display: 'inline-block',
                  width: currentTicket.fmiMemberVerified
                    ? 'calc(100% - 30px)'
                    : '',
                }"
                type="text"
                v-model="currentTicket.fmiMember"
              />
              <img
                v-if="
                  currentTicket.fmiMemberVerified &&
                  currentTicket.fmiMemberVerified == 1
                "
                src="https://www.anm22.it/app/world/libs/anm22_icons/img/anm22_world/verified.png"
                class="verified-badge"
                :title="$anm22.strLang(lang, 'Verified', 'Verificato')"
              />
              <div class="vertical-height-div" style="height: 12px"></div>
            </div>
            <span>{{
              $anm22.strLang(lang, "Tax code", "Codice fiscale")
            }}</span>
            <div class="wg-col">
              <input
                class="input-elem print-elem com-anm22-app-input-text"
                type="text"
                v-model="currentTicket.taxCode"
              />
              <div class="vertical-height-div" style="height: 12px"></div>
            </div>
            <span>{{
              $anm22.strLang(lang, "Birthday", "Data di nascita")
            }}</span>
            <div class="wg-col">
              <input
                class="input-elem print-elem com-anm22-app-input-text"
                type="date"
                v-model="currentTicketBirthday"
              />
              <div class="vertical-height-div" style="height: 12px"></div>
            </div>
            <span>{{
              $anm22.strLang(lang, "Birth city", "Città di nascita")
            }}</span>
            <div class="wg-col">
              <input
                class="input-elem print-elem com-anm22-app-input-text"
                type="text"
                v-model="currentTicket.birthPlaceCity"
              />
              <div class="vertical-height-div" style="height: 12px"></div>
            </div>
            <span>{{
              $anm22.strLang(lang, "Birth state", "Provincia di nascita")
            }}</span>
            <div class="wg-col">
              <input
                class="input-elem print-elem com-anm22-app-input-text"
                type="text"
                v-model="currentTicket.birthPlaceState"
              />
              <div class="vertical-height-div" style="height: 12px"></div>
            </div>
            <span>{{
              $anm22.strLang(lang, "Birth country", "Nazione di nascita")
            }}</span>
            <div class="wg-col">
              <select
                class="input-elem com-anm22-app-select"
                v-model="currentTicket.birthPlaceCountry"
              >
                <option
                  v-for="(obj, key, index) in $anm22.tableClasses
                    .worldCountry()
                    .getAll()"
                  :key="'country-' + index"
                  :value="key"
                >
                  {{ obj[lang] }}
                </option>
              </select>
              <div class="vertical-height-div" style="height: 12px"></div>
            </div>
            <template v-if="mode == 'edit'">
              <div
                style="border-top: 1px solid #ccc; margin-bottom: 10px"
              ></div>
              <span>{{
                $anm22.strLang(lang, "Hospitality pass", "Pass hospitality")
              }}</span>
              <div v-if="currentTicket.pairedCard" style="margin-top: 5px">
                {{
                  $anm22.strLang(
                    lang,
                    "Hospitality access enabled",
                    "Accesso all'hospitality abilitato",
                  )
                }}
                <img
                  :src="$anm22.icons.getWorldIcon('deleteBin')"
                  @click="disableHospitalityAccess()"
                  style="
                    width: 20px;
                    height: 20px;
                    cursor: pointer;
                    display: inline-block;
                  "
                />
              </div>
              <div v-else>
                <input
                  type="button"
                  :value="$anm22.strLang(lang, 'Enable', 'Abilita')"
                  @click="enableHospitalityAccess()"
                />
              </div>
              <div
                style="
                  border-top: 1px solid #ccc;
                  margin-top: 10px;
                  margin-bottom: 10px;
                "
              ></div>
            </template>
          </template>
          <template
            v-else-if="
              ticketTypes.filter(
                (t) => t.idWorldCardType == currentTicket.cardType,
              )[0].isVehicle
            "
          >
            <span>{{
              $anm22.strLang(lang, "Vehicle plate", "Targa veicolo")
            }}</span>
            <div class="wg-col">
              <input
                class="input-elem print-elem com-anm22-app-input-text"
                type="text"
                v-model="currentTicket.vehiclePlate"
              />
              <div class="vertical-height-div" style="height: 12px"></div>
            </div>
          </template>
          <template v-if="currentTicket.pairedCard">
            <span
              >{{
                $anm22.strLang(
                  lang,
                  "Hospitality access paired to badge",
                  "Pass hospitality associato al badge",
                )
              }}
              CIV-{{ currentTicket.pairedCard }}</span
            >
          </template>
          <div class="vertical-height-div" style="height: 20px"></div>
          <div class="wg-row">
            <input
              type="button"
              :value="$anm22.strLang(lang, 'Save', 'Salva')"
              @click="addTicket"
            />
            <input
              type="button"
              :value="$anm22.strLang(lang, 'Delete', 'Elimina')"
              class="red"
              style="margin-left: 10px"
              @click="removeTicket(currentTicket)"
            />
          </div>
        </div>
        <div v-if="ticketTab == 'mail'">
          <div @click="changeTicketTab('main')" class="ticket-tab-back">
            &lt; {{ $anm22.strLang(lang, "Back", "Indietro") }}
          </div>
          <div style="margin-bottom: 20px">
            {{
              $anm22.strLang(
                lang,
                "Send a copy of the pass via e-mail to",
                "Invia una copia del biglietto, con QR Code, via e-mail a",
              )
            }}
            {{ currentTicket.email }}.
          </div>
          <input
            type="button"
            :value="$anm22.strLang(lang, 'Send', 'Invia')"
            @click="sendTicket"
          />
        </div>
        <div v-if="ticketTab == 'logs'">
          <div @click="changeTicketTab('main')" class="ticket-tab-back">
            &lt; {{ $anm22.strLang(lang, "Back", "Indietro") }}
          </div>
          <div class="ticket-tab-title">
            {{ $anm22.strLang(lang, "Logs", "Log") }}
          </div>
          <div class="logs-list">
            <div
              v-for="(log, index) in ticketLogs"
              :key="index"
              class="log-item"
            >
              {{ $moment.unix(log.createdAt).format("YYYY-MM-DD HH:mm") }} |
              {{ log.action }}
              <span v-if="log.user"> | User ID {{ log.user }}</span>
              <div
                v-if="
                  log.action == 'sent-to' ||
                  log.action == 'sent-to-company' ||
                  log.action == 'pass-sent-to'
                "
              >
                {{ log.data }}
              </div>
            </div>
          </div>
        </div>
        <div v-if="ticketTab == 'bracelet'" class="bracelet-tab">
          <div @click="changeTicketTab('main')" class="ticket-tab-back">
            &lt; {{ $anm22.strLang(lang, "Back", "Indietro") }}
          </div>
          <div class="ticket-tab-title">
            {{ $anm22.strLang(lang, "Bracelet", "Pass fisico") }}
          </div>
          <span>{{ $anm22.strLang(lang, "Type", "Tipologia") }}</span>
          <div class="wg-col" style="margin-bottom: 20px">
            <select
              class="input-elem print-elem com-anm22-app-select"
              v-model="currentTicket.physicalPassType"
            >
              <option value="bracelet">
                {{ $anm22.strLang(lang, "Bracelet", "Braccialetto") }}
              </option>
              <option value="pass">
                {{ $anm22.strLang(lang, "Pass", "Pass") }}
              </option>
            </select>
          </div>
          <span>{{
            $anm22.strLang(lang, "Delivery status", "Stato consegna")
          }}</span>
          <div>
            <input
              type="button"
              :value="$anm22.strLang(lang, 'Delivered', 'Consegnato')"
              :disabled="currentTicket.physicalPassStatus == 1"
              @click="updatePhysicalTicketStatus(1)"
            />
            <!--<input
              type="button"
              :value="$anm22.strLang(lang, 'Bag', 'Busta')"
              :disabled="currentTicket.physicalPassStatus == 2"
              @click="updatePhysicalTicketStatus(2)"
            />-->
            <input
              type="button"
              :value="$anm22.strLang(lang, 'Not delivered', 'Non consegnato')"
              :disabled="
                currentTicket.physicalPassStatus != 1 &&
                currentTicket.physicalPassStatus != 2
              "
              @click="updatePhysicalTicketStatus(0)"
            />
          </div>
        </div>
      </div>
    </wg-modal>
    <wg-modal
      v-if="showBundleModal"
      :width="windowWidth > 700 ? '500px' : '80%'"
      :portal="true"
      @closeModal="closeModal"
    >
      <div slot="header" class="com-anm22-app-text-xl">
        <span>{{ $anm22.strLang(lang, "New bundle", "Nuovo bundle") }}</span>
      </div>
      <div slot="body">
        <span>{{ $anm22.strLang(lang, "Company", "Azienda") }}</span>
        <div class="wg-col">
          <input
            class="input-elem print-elem com-anm22-app-input-text"
            type="text"
            v-model="currentBundle.name"
          />
          <div class="vertical-height-div" style="height: 12px"></div>
        </div>
        <span>{{
          $anm22.strLang(lang, "Company e-mail", "Indirizzo e-mail azienda")
        }}</span>
        <div class="wg-col">
          <input
            class="input-elem print-elem com-anm22-app-input-text"
            type="text"
            v-model="currentBundle.companyEmail"
          />
          <div class="vertical-height-div" style="height: 12px"></div>
        </div>
        <span>{{ $anm22.strLang(lang, "Presets", "Pre-set") }}</span>
        <div v-if="bundlePresets" class="bundle-presets-list display-flex">
          <div
            v-for="(bundlePreset, index) in bundlePresets"
            :key="'bundlePreset' + index"
            class="display-flex bundle-preset"
            @click="applyBundlePreset(bundlePreset)"
          >
            <div class="com-anm22-app-text-m" style="white-space: nowrap">
              {{ bundlePreset.name }}
            </div>
          </div>
          <div class="vertical-height-div" style="height: 20px"></div>
        </div>
        <span>{{ $anm22.strLang(lang, "Types", "Tipologie pass") }}</span>
        <div
          v-if="!bundlePresetLoading"
          class="wg-col wg-xs-12 bundle-ticket-types"
        >
          <div
            v-for="(ticketType, index) in bundleTicketTypesList"
            :key="index"
            class="bundle-ticket-type"
          >
            <input
              class="input-elem print-elem com-anm22-app-input-text"
              type="number"
              style="display: inline-block; width: 50px"
              v-model="currentBundle.types[ticketType.idWorldCardType]"
              min="0"
            />
            <img
              v-if="ticketType.isPermanent"
              :src="$anm22.icons.getWorldIcon('public')"
              class="ticket-type-ic"
              :title="$anm22.strLang(lang, 'Permanent', 'Permanente')"
            />
            <img
              v-if="!ticketType.isVehicle && !ticketType.isFood"
              :src="$anm22.icons.getWorldIcon('person')"
              class="ticket-type-ic"
              :title="$anm22.strLang(lang, 'Person', 'Persona')"
            />
            <img
              v-if="ticketType.isVehicle"
              :src="$anm22.icons.getWorldIcon('van')"
              class="ticket-type-ic"
              :title="$anm22.strLang(lang, 'Vehicle', 'Veicolo')"
            />
            <img
              v-if="ticketType.isFood"
              :src="$anm22.icons.getWorldIcon('pickUpRestaurant')"
              class="ticket-type-ic"
              :title="$anm22.strLang(lang, 'Vehicle', 'Veicolo')"
            />
            {{ ticketType.name }}
          </div>
          <div class="vertical-height-div" style="height: 12px"></div>
        </div>
        <div class="vertical-height-div" style="height: 20px"></div>
        <div class="wg-row">
          <input
            type="button"
            :value="$anm22.strLang(lang, 'Send', 'Invia')"
            @click="addBundle"
          />
        </div>
      </div>
    </wg-modal>
    <div style="font-size: 24px" class="com-anm22-app-text-m">
      {{ $anm22.strLang(lang, "Tickets", "Biglietti") }}
    </div>
    <div class="vertical-height-div" style="height: 20px"></div>
    <div class="wg-row tickets-list-menu">
      <input
        type="button"
        :value="$anm22.strLang(lang, 'Add ticket', 'Nuovo biglietto')"
        style="margin-right: 5px"
        @click="add"
      />
      <input
        type="button"
        :value="$anm22.strLang(lang, 'Add ticket', 'Nuovo bundle')"
        @click="openBundleModal"
      />
      <WGPageControls
        :offset="pageOffset"
        :limit="pageResultsNum"
        :itemsNum="totalResultsNum"
        :language="lang"
        :prevPageClick="prevPage"
        :nextPageClick="nextPage"
        :firstPageClick="firstPage"
        :lastPageClick="lastPage"
      ></WGPageControls>
    </div>
    <div class="vertical-height-div" style="height: 20px"></div>
    <div v-if="listFilters.length" class="display-flex">
      <div
        v-for="(filter, index) in listFilters"
        :key="'filter' + index"
        class="display-flex list-filter"
      >
        <div class="com-anm22-app-text-m" style="white-space: nowrap">
          {{ filter }}
        </div>
        <div class="color-selected" style="margin-left: 10px">
          <img
            class="com-anm22-app-img-fixed-height-s"
            :src="$anm22.icons.getWorldIcon('deleteBlack')"
            style="cursor: pointer"
            @click="removeFilter(filter)"
          />
        </div>
      </div>
      <div class="vertical-height-div" style="height: 20px"></div>
    </div>
    <div class="tickets-list">
      <div class="wg-row ticket-row header">
        <div class="name">{{ $anm22.strLang(lang, "Type", "Tipo") }}</div>
        <div class="name">{{ $anm22.strLang(lang, "Company", "Azienda") }}</div>
        <div class="name">{{ $anm22.strLang(lang, "Name", "Nome") }}</div>
        <div class="physicalPass"></div>
        <div class="bracelet"></div>
        <div class="edit"></div>
        <div class="delete"></div>
      </div>
      <div
        class="wg-row ticket-row"
        v-for="(ticket, index) in ticketsList"
        :key="index"
        @click="selectTicket(ticket)"
      >
        <div class="name">
          {{
            ticketTypes.filter((t) => t.idWorldCardType == ticket.cardType)[0]
              .name
          }}
        </div>
        <div class="name">{{ ticket.name }}</div>
        <div class="name">{{ ticket.firstName }} {{ ticket.lastName }}<div v-if="ticket.enabled == true" class="enabled-pass-icon" :title="$anm22.strLang(lang, 'Enabked', 'Abilitato')"></div></div>
        <div class="physical-pass">
          <img
            v-if="
              getTicketType(ticket) &&
              getTicketType(ticket).requiredBracelet &&
              (!ticket.physicalPassStatus ||
              ticket.physicalPassType == 'bracelet')
            "
            :src="$anm22.icons.getWorldIcon('card')"
            class="physical-pass-btn not-delivered"
            :title="
              $anm22.strLang(lang, 'Deliver physical pass', 'Consegna pass')
            "
            @click.stop="updatePhysicalTicketStatusByList(ticket, 1, 'pass')"
          />
          <img
            v-if="
              getTicketType(ticket) &&
              getTicketType(ticket).requiredBracelet &&
              ticket.physicalPassStatus &&
              ticket.physicalPassType == 'pass'
            "
            :src="$anm22.icons.getWorldIcon('card')"
            class="bracelet-btn delivered"
            :title="
              $anm22.strLang(lang, 'Deliver physical pass', 'Consegna pass')
            "
          />
        </div>
        <div class="bracelet">
          <img
            v-if="
              getTicketType(ticket) &&
              getTicketType(ticket).requiredBracelet &&
              (!ticket.physicalPassStatus ||
              ticket.physicalPassType == 'pass')
            "
            :src="$anm22.icons.getWorldIcon('bracelet')"
            class="bracelet-btn not-delivered"
            :title="
              $anm22.strLang(lang, 'Deliver bracelet', 'Consegna bracciale')
            "
            @click.stop="updatePhysicalTicketStatusByList(ticket, 1, 'bracelet')"
          />
          <img
            v-if="
              getTicketType(ticket) &&
              getTicketType(ticket).requiredBracelet &&
              ticket.physicalPassStatus &&
              ticket.physicalPassType == 'bracelet'
            "
            :src="$anm22.icons.getWorldIcon('bracelet')"
            class="bracelet-btn delivered"
            :title="
              $anm22.strLang(lang, 'Deliver bracelet', 'Consegna bracciale')
            "
          />
        </div>
        <div class="edit">
          <img
            :src="$anm22.icons.getWorldIcon('edit')"
            class="edit-btn"
            :title="$anm22.strLang(lang, 'Edit', 'Modifica')"
            @click="selectTicket(ticket)"
          />
        </div>
        <div class="delete">
          <img
            :src="$anm22.icons.getWorldIcon('deleteBin')"
            class="delete-btn"
            :title="$anm22.strLang(lang, 'Delete', 'Elimina')"
            @click.stop="removeTicket(ticket)"
          />
        </div>
      </div>
      <div class="empty-list-msg" v-if="!tickets || totalResultsNum == 0">
        {{ $anm22.strLang(lang, "No tickets.", "Nessun biglietto.") }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import WGPageControls from "../../../../world/spa/components/WGPageControls.vue";
import TicketPrint from "./TicketPrint.vue";
import motorsport from "../../libs/motorsport";

export default {
  components: {
    WGPageControls,
    TicketPrint,
  },
  data() {
    return {
      tickets: [],
      ticketTypes: [],
      mode: "edit",
      openModal: false,
      showBundleModal: false,
      currentTicket: {},
      currentBundle: {},
      pageResultsNum: 50,
      pageOffset: 0,
      totalResultsNum: 0,
      listFilters: [],
      ticketTab: "main",
      ticketLogs: [],
      printRequestTrigger: 0,
      bundlePresetLoading: false,
      showUpdatedBadge: false,
      bundlePresets: [
        {
          name: "CIV Rider",
          types: [
            {
              type: 1403,
              quantity: 1,
            },
            {
              type: 1412,
              quantity: 3,
            },
            {
              type: 1405,
              quantity: 1,
            },
            {
              type: 1427,
              quantity: 2,
            },
          ],
        },
        {
          name: "CIV Rider Estero",
          types: [
            {
              type: 1404,
              quantity: 1,
            },
            {
              type: 1412,
              quantity: 3,
            },
            {
              type: 1405,
              quantity: 1,
            },
            {
              type: 1427,
              quantity: 2,
            },
          ],
        },
        {
          name: "CIV Team ENTRY",
          types: [
            {
              type: 1395,
              quantity: 1,
            },
            {
              type: 1412,
              quantity: 4,
            },
            {
              type: 1396,
              quantity: 1,
            },
            {
              type: 1405,
              quantity: 1,
            },
            {
              type: 1427,
              quantity: 4,
            },
          ],
        },
        {
          name: "CIV Team MULTISERVICE",
          types: [
            {
              type: 1395,
              quantity: 1,
            },
            {
              type: 1412,
              quantity: 6,
            },
            {
              type: 1396,
              quantity: 2,
            },
            {
              type: 1405,
              quantity: 1,
            },
            {
              type: 1427,
              quantity: 7,
            },
          ],
        },
        {
          name: "Coppa Italia Piloti",
          types: [
            {
              type: 1530,
              quantity: 4,
            },
            {
              type: 1484,
              quantity: 1,
            },
            {
              type: 1583,
              quantity: 2,
            },
            {
              type: 1504,
              quantity: 1,
            },
            {
              type: 1505,
              quantity: 1,
            },
            {
              type: 1506,
              quantity: 1,
            },
            {
              type: 1507,
              quantity: 1,
            },
            {
              type: 1508,
              quantity: 1,
            },
          ],
        },
      ],
    };
  },
  computed: {
    ...mapState({
      lang: (state) => state.lang,
      windowWidth: (state) => state.windowWidth,
    }),
    ticketRoles() {
      return motorsport.getRoles();
    },
    ticketsList() {
      return this.tickets;
    },
    bundleTicketTypesList() {
      return this.ticketTypes
        .filter((t) => !t.deleted)
        .sort((a, b) => {
          if (a.isPermanent < b.isPermanent) return 1;
          if (a.isPermanent > b.isPermanent) return -1;
          if (a.isVehicle < b.isVehicle) return -1;
          if (a.isVehicle > b.isVehicle) return 1;
          if (a.isFood < b.isFood) return -1;
          if (a.isFood > b.isFood) return 1;
          if (a.name < b.name) return -1;
          if (a.name > b.name) return 1;
          return 0;
        });
    },
    currentTicketBirthday: {
      get() {
        return this.$moment
          .unix(this.currentTicket.birthday)
          .format("YYYY-MM-DD");
      },
      set: _.debounce(function (newVal) {
        this.currentTicket.birthday = Number(
          this.$moment(newVal + " 12:00")
            .utc()
            .format("X"),
        );
      }, 1000),
    },
  },
  methods: {
    searchFn(string) {
      let results = [
        {
          label: string,
          img: this.$anm22.icons.getWorldIcon("searchLeft"),
          submitFn: () => {
            this.addFilter(string);
          },
        },
      ];
      return results;
    },
    loadData() {
      let controllerUrl =
        "tickets?offset=" + this.pageOffset + "&limit=" + this.pageResultsNum;
      if (this.listFilters.length) {
        controllerUrl += "&filters=";
        for (var f = 0; f < this.listFilters.length; f++) {
          controllerUrl += encodeURI(this.listFilters[f]) + ",";
        }
      }
      this.$http
        .get(controllerUrl)
        .then((response) => {
          this.tickets = response.data.cards;
          this.ticketTypes = response.data.cardTypes;
          this.totalResultsNum = response.data.cardsNum;
          if (this.pageOffset >= this.totalResultsNum) {
            this.lastPage();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    loadCurrentTicket() {
      let controllerUrl = "tickets/get?id=" + this.currentTicket.idWorldCard;
      this.$http
        .get(controllerUrl)
        .then((response) => {
          this.currentTicket = response.data.card;
          this.ticketLogs = response.data.logs;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    add() {
      this.currentTicket = {};
      this.openModal = true;
      this.mode = "new";
      this.ticketTab = "main";
    },
    openBundleModal() {
      this.currentBundle = {
        types: {},
      };
      this.showBundleModal = true;
    },
    addTicket() {
      if (this.mode == "new") {
        this.$http
          .post(
            "tickets/save",
            {
              ticket: this.currentTicket,
            },
            {
              withCredentials: true,
            },
          )
          .then((response) => {
            this.$anm22.eventBus.$emit("wg-modal-close");
            this.selectTicket(response.data.ticket);

            this.showUpdatedBadge = true;
            setTimeout(() => {
              this.showUpdatedBadge = false;
            }, 1000);
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.$http
          .post(
            "tickets/save",
            {
              ticket: this.currentTicket,
            },
            {
              withCredentials: true,
            },
          )
          .then((response) => {
            this.loadData();
            this.loadCurrentTicket();

            this.showUpdatedBadge = true;
            setTimeout(() => {
              this.showUpdatedBadge = false;
            }, 1000);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    removeTicket(ticket) {
      this.currentTicket = ticket;
      this.currentTicket.deleted = 1;
      this.mode = "edit";
      this.addTicket();
      this.closeModal();
    },
    updatePhysicalTicketStatus(status) {
      this.currentTicket.physicalPassStatus = status;
      this.$http
        .post(
          "tickets/delivery",
          {
            ticket: this.currentTicket,
          },
          {
            withCredentials: true,
          },
        )
        .then((response) => {
          this.loadData();
          this.loadCurrentTicket();
          this.changeTicketTab("main");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    updatePhysicalTicketStatusByList(ticket, status, type) {
      ticket.physicalPassStatus = status;
      ticket.physicalPassType = type;
      this.$http
        .post(
          "tickets/delivery",
          {
            ticket: ticket,
          },
          {
            withCredentials: true,
          },
        )
        .then((response) => {
          this.loadData();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    selectTicket(ticket) {
      this.mode = "edit";
      this.openModal = true;
      this.currentTicket = ticket;
      this.loadCurrentTicket();
      this.ticketTab = "main";
    },
    closeModal() {
      this.loadData();
      this.openModal = false;
      this.showBundleModal = false;
    },
    changeTicketTab(tab) {
      this.ticketTab = tab;
    },
    addBundle() {
      this.$http
        .post(
          "tickets/bundle",
          {
            bundle: this.currentBundle,
          },
          {
            withCredentials: true,
          },
        )
        .then((response) => {
          this.$anm22.eventBus.$emit("wg-modal-close");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    applyBundlePreset(bundlePreset) {
      this.bundlePresetLoading = true;
      for (var i = 0; i < bundlePreset.types.length; i++) {
        this.currentBundle.types[bundlePreset.types[i].type] =
          bundlePreset.types[i].quantity;
      }
      this.bundlePresetLoading = false;
    },
    nextPage() {
      if (this.pageOffset + this.pageResultsNum < this.totalResultsNum) {
        this.pageOffset += this.pageResultsNum;
      }
      this.loadData();
    },
    prevPage() {
      if (this.pageOffset > 0) {
        this.pageOffset -= this.pageResultsNum;
      }
      this.loadData();
    },
    firstPage() {
      this.pageOffset = 0;
      this.loadData();
    },
    lastPage() {
      if (this.totalResultsNum <= 0) {
        this.pageOffset = 0;
      } else {
        this.pageOffset =
          Math.floor((this.totalResultsNum - 1) / this.pageResultsNum) *
          this.pageResultsNum;
        this.loadData();
      }
    },
    addFilter(filter) {
      this.listFilters.push(filter);
      this.loadData();
    },
    removeFilter(filterToRemove) {
      this.listFilters = this.listFilters.filter((f) => f !== filterToRemove);
      this.loadData();
    },
    getTicketType(ticket) {
      let types = this.ticketTypes.filter(
        (t) => t.idWorldCardType == ticket.cardType,
      );
      return types ? types[0] : null;
    },
    sendTicket() {
      let controllerUrl =
        "https://com-anm22-civ.anm22.it/controllers/pass-send-via-email?t=" +
        this.currentTicket.idWorldCard;
      this.$http
        .get(controllerUrl)
        .then((response) => {
          this.changeTicketTab("main");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    enableHospitalityAccess() {
      this.$http
        .post(
          "tickets/enable-hospitality-paired-pass",
          {
            ticket: this.currentTicket,
          },
          {
            withCredentials: true,
          },
        )
        .then((response) => {
          this.loadData();
          this.loadCurrentTicket();

          this.showUpdatedBadge = true;
          setTimeout(() => {
            this.showUpdatedBadge = false;
          }, 1000);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    disableHospitalityAccess() {
      this.$http
        .post(
          "tickets/disable-hospitality-paired-pass",
          {
            ticket: this.currentTicket,
          },
          {
            withCredentials: true,
          },
        )
        .then((response) => {
          this.loadData();
          this.loadCurrentTicket();

          this.showUpdatedBadge = true;
          setTimeout(() => {
            this.showUpdatedBadge = false;
          }, 1000);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  created() {
    this.loadData();
  },
  mounted() {
    this.$anm22.eventBus.$emit("world-headbar-search-config", {
      hintFn: this.searchFn,
    });
  },
};
</script>

<style lang="scss" scoped>
.tickets-list {
  overflow-x: auto;

  .ticket-row {
    border-radius: 8px;
    min-height: 49px;
    padding: 5px;
    flex-wrap: nowrap;
    cursor: pointer;
    max-width: 1700px;

    &:hover {
      background-color: #f9f9f9;
    }
    div {
      display: inline-block;
      vertical-align: top;
      white-space: normal;
      padding: 11px;

      &.code {
        flex: 1;
        width: 10%;
        min-width: 60px;
        word-wrap: break-word;
      }
      &.name {
        flex: 3;
        width: 15%;
        min-width: 120px;
      }
      &.category {
        flex: 1;
        width: 15%;
        min-width: 120px;
      }
      &.quantity {
        width: 10%;
        min-width: 60px;
      }
      &.color {
        width: 42px;

        .color-preview {
          border: 1px solid #ddd;
          border-radius: 10px;
          box-sizing: border-box;
          width: 16px;
          height: 16px;
          padding: 0;
        }
      }
      &.edit,
      &.delete,
      &.bracelet,
      &.physical-pass {
        padding: 8px;
        width: 36px;

        .edit-btn,
        .delete-btn,
        .bracelet-btn,
        .physical-pass-btn {
          width: 20px;
          height: 20px;
          cursor: pointer;
        }

        .bracelet-btn,
        .physical-pass-btn {
          &.not-delivered {
            opacity: 0.3;

            &:hover {
              opacity: 1;
            }
          }
          &.delivered {
            cursor: default;
          }
        }
      }

      @media (max-width: 500px) {
        &.bracelet {
          display: none;
        }
        &.physical-pass {
          display: none;
        }
      }
    }

    .enabled-pass-icon {
      display: inline-block;
      background-color: #4caf50;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      padding: 0;
      margin: 0 0 0 5px;
      vertical-align: middle;
    }

    &.header {
      div {
        font-weight: 600;
      }

      &:hover {
        background: none !important;
      }
    }
  }

  .empty-list-msg {
    padding: 16px;
  }
}

.tickets-list-menu {
  align-items: center;
  max-width: 1700px;
}

.list-filter {
  align-items: center;
  flex-wrap: nowrap;
  background-color: #e9e9ea;
  font-size: 14px;
  padding: 10px;
  border-radius: 10px;
  margin: 5px 10px 5px 0;
  cursor: pointer;
}

.ticket-modal-title {
  vertical-align: middle;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ticket-updated-badge {
  color: #fff;
  background-color: #4caf50;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
  font-size: 14px;
  text-align: center;
  font-weight: 500;
  box-sizing: border-box;
  padding-top: 2px;
  margin-left: 6px;
  position: absolute;
  top: 14px;
  right: 36px;
}

.ticket-tab-back {
  cursor: pointer;
  font-weight: 500;
  margin-bottom: 20px;
}

.ticket-tab-title {
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 20px;
}

.ticket-action-cards {
  overflow-y: hidden;
  overflow-x: auto;
  white-space: nowrap;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 20px;

  .action-card {
    border: 1px solid #fff;
    border-radius: 6px;
    padding: 6px;
    font-size: 14px;
    font-weight: 500;
    width: 100px;
    min-width: 100px;
    height: 60px;
    white-space: normal;
    user-select: none;
    overflow: hidden;
    background-repeat: no-repeat;
    background-position: 75px 38px;
    background-size: 16px auto;

    &.link {
      border: 1px solid #ccc;
      cursor: pointer;

      &:hover {
        border: 1px solid #aaa;
      }
    }

    &.inside {
      background-color: #42a5f5;
    }
    &.done {
      background-color: #76ff03;
      background-image: url("https://www.anm22.it/app/world/libs/anm22_icons/img/icons/done.svg");
    }
    &.warning {
      background-color: #ffc400;
      background-image: url("https://www.anm22.it/app/world/libs/anm22_icons/img/icons/warning.svg");
    }
    &.error {
      position: relative;
      background-color: #d50000;
      color: #fff;
    }
    &.email {
      background-image: url("https://www.anm22.it/app/world/libs/anm22_icons/img/icons/email.svg");
    }
    &.list {
      background-image: url("https://www.anm22.it/app/world/libs/anm22_icons/img/icons/list.svg");
    }
    &.bracelet {
      background-image: url("https://civ.anm22.it/img/icons/fitness-tracker.svg");
    }
    &.print {
      background-image: url("https://www.anm22.it/app/world/libs/anm22_icons/img/icons/printer.svg");
    }
  }
}

.ticket-id {
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: 500;
}

.verified-badge {
  display: inline-block;
  vertical-align: middle;
  height: 16px;
  margin-left: 8px;
}

input[type="button"]:disabled {
  opacity: 0.5;
  cursor: default;

  &:hover {
    background-color: #e9e9ea;
  }
}

.logs-list {
  margin-bottom: 20px;

  .log-item {
    margin-bottom: 5px;
  }
}

.bracelet-tab {
  input[type="button"] {
    margin: 6px;
  }
}

.bundle-presets-list {
  .bundle-preset {
    align-items: center;
    flex-wrap: nowrap;
    background-color: #e9e9ea;
    font-size: 14px;
    padding: 10px;
    border-radius: 10px;
    margin: 5px 10px 5px 0;
    user-select: none;
    cursor: pointer;

    &:hover {
      background-color: #ddd;
    }
  }
}

.bundle-ticket-types {
  .bundle-ticket-type {
    margin: 2px 0;

    input {
      margin-right: 8px;
    }

    .ticket-type-ic {
      display: inline-flex;
      text-align: center;
      width: 20px;
      height: 20px;
      margin-right: 8px;
    }
  }
}
</style>
